export const us = [
    {
        id: "content-us-world-news",
        name: "اخبار العالم",
        articles: [
            {
                id: "31b24534-29f6-469f-8ce3-ff774997ef8a",
                class: "columns-3-wide",
                header: "يحدث اليوم",
                url: "#",
                image: {
                    src: "assets/images/todd-trapani-vS54KomBEJU-unsplash_684.jpg",
                    alt: "عنصر نائب",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                    tag: {
                        type: "breaking",
                        label: "كسر",
                    },
                },
                title: "لكن إنفاذ التنفيذ البيئي المغذي الحراري القابل للخصم.",
                type: "text",
                content:
                    "من غير حاول والفلبين اليابان،, فعل احداث اتفاقية في. في وصل وبعض عقبت وجهان, قائمة السيء ولكسمبورغ ومن أي, هاربر غرّة، هذه إذ. عل كلا الشمال وفنلندا, نفس كل لعملة التّحول ومحاولة, أوسع الجنوب الخاطفة دون هو. نفس مليون نهاية استعملت إذ, من الجنوبي وهولندا، أخر. جهة قد بالجانب بمحاولة ولاتّساع, أسر تم بوابة النفط وبحلول. فعل وبدأت اوروبا إذ. حقول وبعد وفي ٣٠, للجزر الأبرياء و شيء. دفّة العدّ الضروري دار أم, عل التي مقاومة الجنوبي بال. بـ ولم منتصف بالرّغم, عن أفاق الشرق، بريطانيا-فرنسا بال. مع نفس الأحمر الصعداء, بحث يقوم لهذه بـ.",
            },
            {
                id: "06f7b876-6120-4273-8850-f60f817940f0",
                class: "columns-3-narrow",
                header: "الشائع",
                url: "#",
                image: {
                    src: "assets/images/mufid-majnun-tJJIGh703I4-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "من أجل تنشيط سيناريو حياة فقط تحتاج إلى شيء عظيم.",
                type: "text",
                content:
                    "هذا ليس تصنيعًا معينًا لكرة القدم يركض ضحكًا في كرة السلة.بطولة وثيقة الهوية الوحيدة لايف الكحول تشرب الشراب كدبابات.فقط حتى الضعف القطر.تدليك كرة السلة حامل للغاية سريري للاستثمار.فالي تيلوس معرف البروتين معرف.\n\nلدحر السيء وهولندا، أم ولم, أما وإيطالي ألمانيا بالسيطرة بـ. ما رئيس الواقعة باستحداث حيث, أن الله قتيل، حول. عل الوراء الجنود أما, تعد قد اللازمة الأولية, أم تعديل والمانيا الإيطالية انه. تم لكل تعديل السيطرة ايطاليا،. لدحر والنفيس بريطانيا مع وتم, أوسع مليون أضف ٣٠, من وحرمان المشتّتون وقد.",
            },
            {
                id: "e9f3877f-a2a6-41fb-898b-9acb0fdedc19",
                class: "columns-3-narrow",
                header: "طقس",
                url: "#",
                image: {
                    src: "assets/images/noaa--urO88VoCRE-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "هذا الفلفل الحار الطماطم إلى عنصر الكرة الطائرة الحلق.",
                type: "list",
                content: [
                    {
                        id: "2ed5ca3f-6fca-4061-b055-d79058547e93",
                        content: "سكان التغذية كرة القدم الحزين الشيخوخة.أو الفول السوداني Til ووقت الكراهية Orci بروتين كرة السلة في.",
                    },
                    {
                        id: "afcab89c-38d8-4d5e-9b52-cd560cb92d96",
                        content: "أنا أكره الراحة في نهاية الأسبوع في نهاية الأسبوع ، لكن إنفاذ إنفاذ التنفيذ البيئي.",
                    },
                    {
                        id: "e9c96309-74a2-4ceb-b0de-8b1a6be4fbdc",
                        content:
                            "لدحر السيء وهولندا، أم ولم, أما وإيطالي ألمانيا بالسيطرة بـ. ما رئيس الواقعة باستحداث حيث, أن الله قتيل، حول. عل الوراء الجنود أما, تعد قد اللازمة الأولية, أم تعديل والمانيا الإيطالية انه. تم لكل تعديل السيطرة ايطاليا،. لدحر والنفيس بريطانيا مع وتم, أوسع مليون أضف ٣٠, من وحرمان المشتّتون وقد.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-around-the-nation",
        name: "في جميع أنحاء البلاد",
        articles: [
            {
                id: "4e19c383-aff6-45de-b874-008c58a9667f",
                class: "columns-3-balanced",
                header: "أحدث",
                image: {
                    src: "assets/images/fons-heijnsbroek-vBfEZdpEr-E-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "تم تكوين 1 فقرة، 5 كلمة، 27 بايت من نص لوريم إيبسوم",
                type: "list",
                content: [
                    {
                        id: "f3197d93-1041-423d-b648-f7b717f7ea9d",
                        content: "بال بالعمل جديداً ماليزيا، ان. عن بها مليارات المتحدة",
                    },
                    {
                        id: "aa2cfed6-54e2-468d-9a03-dd4db4cab1b4",
                        content: "آسف على كرة القدم التي تخرجت.",
                    },
                    {
                        id: "37a7a6b1-710f-45da-a481-2a23c0d90a31",
                        content: "حين. خطّة بشرية أوراقهم حدى في, ما والتي أعمال العالمية دار. مكن",
                    },
                    {
                        id: "48103727-1181-4b8c-b536-062e8a868106",
                        content: "أنا لا الدردشة الكحول الحامل و.من المهم مضادات الأكسدة الكبيرة حتى وقت كرة القدم السريرية.",
                    },
                ],
            },
            {
                id: "53c3567d-6073-41e8-87ca-f76a282c38f9",
                class: "columns-3-balanced",
                header: "عمل",
                image: {
                    src: "assets/images/bram-naus-oqnVnI5ixHg-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "نطاق تصنيع مطور التغذية.للكرتون الشوكولاته الاحماء مع الرقبة.",
                type: "list",
                content: [
                    {
                        id: "2f03cb48-b182-46e7-a651-3bd04ee622bb",
                        content: "جُل بشرية إستعمل إذ, بـ جعل خيار لغات تسبب. لم الإمتعاض الإتفاقية وتم, دنو كل",
                    },
                    {
                        id: "4cf064fc-6ad2-4ef4-9bca-ac6607da0912",
                        content: "لأوربيين ثم ذات, و تشكيل إعلان أضف. جُل الضروري الخاصّة ان, الإمداد عشو",
                    },
                    {
                        id: "5fad11d7-ba53-487f-af21-e86b68a98d21",
                        content: "أوروبا ولاتّساع وحلفاؤها تم جهة, عل جعل وعلى وجهان والنرويج",
                    },
                ],
            },
            {
                id: "79344d21-3a1f-4531-87b7-971d0a01e959",
                class: "columns-3-balanced",
                header: "سياسة",
                image: {
                    src: "assets/images/hansjorg-keller-CQqyv5uldW4-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "آلام المكتب وظيفية رائعة.كما أنها ليست العقارات الآن هي أن أسهم عنصر المنطقة.",
                type: "list",
                content: [
                    {
                        id: "68ad5e3b-68ae-41da-ab0d-a073c78a4ca7",
                        content: "دون قد بخطوط الشهير, قد يقوم الهادي والروسية جهة, أدنى الإطلاق",
                    },
                    {
                        id: "c48f6f5f-6be3-41ec-a067-c1dc072c0beb",
                        content: "بـ, أخرى وتزويده جُل ما. كل سقطت الصفحة وفنلندا إيو, حصدت ",
                    },
                    {
                        id: "1917cf48-ce4b-4e80-8828-3b104fbacff7",
                        content: "قبل من الأمور الطرفين ولكسمبورغ, قبل غريمه أطراف إتفاقية عن, و",
                    },
                    {
                        id: "13fb8e39-13c9-4f97-a15f-95bde9351960",
                        content: "لم الإمتعاض الإتفاقية وتم, دنو كل وفنلندا وبالتحديد،, بخطوط وبلجيكا، بين بل. مشا",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-roundup",
        name: "جمع الشمل",
        articles: [
            {
                id: "660d5f2a-0977-423b-a585-dbd0f58695e4",
                class: "columns-wrap",
                header: "واشنطن",
                type: "excerpt",
                content: [
                    {
                        id: "bd34fb90-27ff-4e57-b29b-1cec6c56b423",
                        image: {
                            src: "assets/images/unseen-histories-4kYkKW8v8rY-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "مرجع الأوروبيّون عن ذلك. بل لمّ بزمام تجهيز بمحاولة, يكن قد جيوب إستيلاء, ودول بينما الإطلاق ما حتى. بعد بل اسبوعين الإيطالية الإقتصادية. مما ان فرنسا ديسمبر إستيلاء, و منتصف تحرّكت أخذ.",
                    },
                    {
                        id: "30a4e957-4170-4613-8d9a-5b417b999568",
                        image: {
                            src: "assets/images/ian-hutchinson-P8rgDtEFn7s-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "قبل من الأمور الطرفين ولكسمبورغ, قبل غريمه أطراف إتفاقية عن, و لمّ وجهان مشاركة. إذ لمّ الهادي بالمطالبة, إذ ٢٠٠٤ كنقطة اليها حين. خطّة بشرية أوراقهم حدى في, ما والتي أعمال العالمية دار. مكن ٣٠ ليبين قتيل، عسكرياً. ما الصفحات استرجاع مكن.",
                    },
                    {
                        id: "ffc520db-68a5-451e-89df-86be7e126c10",
                        image: {
                            src: "assets/images/koshu-kunii-ADLj1cyFfV8-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بال بالعمل جديداً ماليزيا، ان. عن بها مليارات المتحدة, كردة واتّجه قُدُماً قام و. عل مارد الصين مساعدة كما. سابق الإنزال أي أسر, معزّزة بالحرب ضرب في. تم أضف خيار مواقعها.",
                    },
                ],
            },
            {
                id: "c88e0e0d-e323-4d4e-a0fb-b72c3fda9df8",
                class: "columns-wrap",
                header: "الساحل الشرقي",
                type: "excerpt",
                content: [
                    {
                        id: "f93e2af2-f8ff-4706-8290-11a2cec073eb",
                        image: {
                            src: "assets/images/matthew-landers-v8UgmRa6UDg-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "جُل بشرية إستعمل إذ, بـ جعل خيار لغات تسبب. لم الإمتعاض الإتفاقية وتم, دنو كل وفنلندا وبالتحديد،, بخطوط وبلجيكا، بين بل. مشارف الأوربيين ثم ذات, و تشكيل إعلان أضف. جُل الضروري الخاصّة ان, الإمداد عشوائية وقد ثم, عرض بل أملاً ديسمبر. مع لغزو بالعمل ذات, فاتّبع الأمور جعل كل.",
                    },
                    {
                        id: "1298a3c4-6638-4afd-a34c-56ab2eaf281d",
                        image: {
                            src: "assets/images/c-j-1GHqOftzYo0-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "إذ قادة المضي النزاع قام, ما كلا وأكثرها ومطالبة الساحلية. قتيل، المضي ولم أم. ثم مما اتّجة الإكتفاء. قبل و أساسي بالسيطرة, حول أن بلاده معزّزة. و بقصف مسارح الإنذار، ذلك, تعد أمّا بهيئة الوراء مع.",
                    },
                    {
                        id: "5e765702-4e99-4cc5-b958-aad34be0b826",
                        image: {
                            src: "assets/images/jacob-licht-8nA_iHrxHIo-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "يكن الفترة وتنامت العالمي بـ, انتباه الربيع، باستحداث فصل عن. بعض ثم خطّة القادة. نقطة مرمى تم جُل, حيث قد تجهيز إستعمل التبرعات, يتبقّ رجوعهم إذ عدد. أسيا الشتاء عل شيء. معارضة وبالتحديد، قد أخذ. لان فكان بلديهما ثم, لدحر فهرست بل نفس.",
                    },
                ],
            },
            {
                id: "a2267128-dd86-4a98-8903-0a887d49104e",
                class: "columns-wrap",
                header: "الساحل الغربي",
                type: "excerpt",
                content: [
                    {
                        id: "9c59f003-1eb3-4a86-9a00-9012470c2549",
                        image: {
                            src: "assets/images/maria-lysenko-tZvkSuBleso-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "لها لغزو للمجهود لم. الخاصّة اقتصادية من حول, بعض قد لإعلان الإنزال الإمتعاض. بعض إذ إحكام الآلاف, أن هذا مقاطعة بالمحور. كل إحتار اعلان الى, بل به، مارد بخطوط المسرح.",
                    },
                    {
                        id: "951ecd15-5add-4f8a-8eaf-053be96c923b",
                        image: {
                            src: "assets/images/peter-thomas-17EJD0QdKFI-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "أوروبا ولاتّساع وحلفاؤها تم جهة, عل جعل وعلى وجهان والنرويج. بحشد أكثر هو به،, كان وإقامة استبدال لم. لمّ تصفح وفرنسا إذ, فقد أطراف إتفاقية ما, فصل اعتداء الطرفين ان. قُدُماً التجارية بـ مدن. مقاومة والروسية ايطاليا، كان أم, ان ومحاولة المشتّتون وقد, مما أم وحتى بتخصيص. دنو قد الجو ويتّفق, ثم الأولية الخارجية ويكيبيديا إيو, الأثنان واستمرت باستخدام من لكل.",
                    },
                    {
                        id: "450f1f73-9d36-497a-bab0-6ca7c28c4f68",
                        image: {
                            src: "assets/images/xan-griffin-QxNkzEjB180-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "والنفيس التاريخ، بريطانيا، تم وقد, يذكر علاقة به، أم. أم يبق العدّ الساحة, المضي وكسبت انه قد, إتفاقية والديون الأراضي ما هذا. حول تم خيار الولايات, المجتمع المتحدة الأوروبية، بحق ما, تم للصين الأمور العمليات تحت. مليون هاربر المشتّتون لم عرض. بهيئة الغالي كما مع, ان بتخصيص مشاركة بالإنزال انه, وبعض مشروط ان بلا.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-crime+justice",
        name: "الجريمة والعدالة",
        articles: [
            {
                id: "bc92acd8-0cbb-42e6-88dc-7589e92eb218",
                class: "columns-3-balanced",
                header: "المحكمة العليا",
                type: "articles-list",
                content: [
                    {
                        id: "a795ce54-f3f2-4a32-b59d-2a88530638dd",
                        title: "أو ابتسامة أو راحة سحب.",
                        content:
                            "سابق أفريقيا الإتحاد في يكن, شمال لغات الحرة ٣٠ الى, أي بأضرار وحلفاؤها الرئيسية إيو. هو الى قامت البرية تزامناً, أم دفّة الحيلولة يبق. ان خلاف انذار مدن, مايو لإنعدام عل به،. المدن باستحداث لبلجيكا، من بحث, و أعمال الشرق، الجنرال بعض, و مارد بالرغم بالإنزال بعد. كل عقبت أكثر الربيع، شيء, ان أهّل ماشاء مدن. أحدث احداث بـ جُل, الحرة يتعلّق بلا هو.",
                    },
                    {
                        id: "7add8464-9b82-428a-a8ec-6489b6c4f830",
                        title: "الكثير من الضعف مات هو.",
                        content:
                            "حتى ان لإعلان التغييرات, بـ وأزيز التجارية بريطانيا، بها. كل وبدأت يعادل لتقليعة حدى. ساعة ضمنها الفرنسي ٣٠ أضف. وصل في هُزم كانتا وإعلان, ما الى شواطيء اللازمة. بال كثيرة واتّجه الهادي ثم, بشكل ووصف الأرضية قام ما.",
                    },
                    {
                        id: "45aa7276-1a3a-4be7-bd1c-c4885dd7e9e0",
                        title: "موريس في بعض السلطة البيئية مثل مطوري كرة القدم.",
                        content:
                            "هو دول المضي الإحتفاظ الإمتعاض, بينما أعلنت قُدُماً جُل لم, الأحمر الخاسرة بل جُل. بل أخذ معقل الأجل الصعداء, الله اوروبا بالجانب أي عدم. الشتاء العظمى حاملات كل ضرب, عدم دخول مئات المزيفة في. بحشد اتفاق شيء أن, بـ أخذ تشكيل قبضتهم اللازمة. انه قد وحرمان الساحلية الأوروبي.",
                    },
                ],
            },
            {
                id: "190711e5-6bc8-4b26-920a-b6edd74a0847",
                class: "columns-3-balanced",
                header: "قانون محلي",
                type: "articles-list",
                content: [
                    {
                        id: "a126bcfa-9915-4cd4-8a7f-db36ba5e426e",
                        title: "الكثير من العلاج حتى الضعف القطر.",
                        content:
                            "مشروط العدّ المتحدة في جُل. مع شدّت تكبّد الإطلاق تلك, والكوري والمانيا الى عل, جعل تم مليون العسكري المجتمع. كلا شرسة البولندي الساحلية مع, الى هو بقعة تنفّس واقتصار. إذ لفشل ديسمبر لكل, و حتى إبّان بريطانيا-فرنسا. للسيطرة العسكري المنتصر أن عرض, وتم وصافرات التقليدي أي.",
                    },
                    {
                        id: "de6f2266-ab8b-4312-b11c-78258500035b",
                        title: "أحدث أسهم كرة السلة السريرية من الفلفل الحار تحتاج دائمًا إلى الواجب المنزلي.",
                        content:
                            "أم الشرق، معزّزة الحيلولة الى. الصين شواطيء إذ قبل, مرمى الأهداف ثم الا, و بعض أراض والديون. أم كردة بقسوة وبالرغم على. إعادة ماشاء العسكري حتى عن, وإعلان العظمى عل كما, بحشد حقول لهذه أم فقد. لان العصبة والمعدات من, بقصف المضي المواد كل يتم. سكان ويتّفق وإيطالي فعل كل, ثم بال أوزار فشكّل, تكبّد التاريخ، التغييرات جعل عن.",
                    },
                    {
                        id: "2bac47f6-54c2-4c57-87cc-3a3f202ab290",
                        title: "الشوكولاتة الشوكولاتة الشوكولاتة في الأرز.",
                        content:
                            "إحكام للمجهود جهة قد, وصل ووصف أوسع للحكومة عن. وشعار عسكرياً التقليدية لم كما, كما ما ماذا ومضى تطوير, تحرّك بالحرب قد بحق. أن أمّا اتفاق لها. ماذا ٠٨٠٤ وبولندا عن قبل, لها وقام التّحول استرجاع عن. قد سياسة غرّة، كلّ, و جُل أطراف إستيلاء.",
                    },
                ],
            },
            {
                id: "0233b0b6-69f1-4c51-81cd-b849e435f2c1",
                class: "columns-3-balanced",
                header: "رأي",
                type: "articles-list",
                content: [
                    {
                        id: "ad0f3eb3-42eb-43f5-bd8d-9a3b62ec5433",
                        title: "رائع وتصنيع العقارات المختارة.",
                        content:
                            "ثم الجنرال الأوربيين يكن. تعد الذود تحرير وباءت ٣٠. تم لكل مليون سبتمبر شموليةً. وبعض سبتمبر يتعلّق بلا عن, إيو قائمة أجزاء و, ثم بعد للمجهود وبولندا. و أسر مرجع الخطّة اوروبا, من ذات وعُرفت الإنزال. اتفاق الشمل بمباركة بال أن, تلك أن السيطرة الأعمال, وحتّى السيطرة بريطانيا أن لها.",
                    },
                    {
                        id: "b49fe19d-4bcc-42bb-9b85-8348cc64d4ca",
                        title: "خلافاَ للإعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً،",
                        content:
                            "لمّ إبّان وباءت الإثنان عل, مكن الطريق الشّعبين ٣٠. فقد خطّة وترك يتسنّى ان, الفرنسية ولكسمبورغ بـ حيث, أسر قد الأمريكي الإقتصادية. أي بين تطوير النزاع, المحيط النزاع عسكرياً بعد لم. كما معارضة للسيطرة انتصارهم و, عن وإقامة الإقتصادية أضف. من أسر الأوضاع الدنمارك انتصارهم, اليميني لإنعدام يكن إذ. تشكيل بريطانيا، لمّ بل, كل واُسدل للسيطرة بحث, انه ان هُزم التبرعات.",
                    },
                    {
                        id: "65ca4cde-546a-496a-b731-71140adfb651",
                        title: "لكلاسيكي منذ العام 45 قبل الميلاد، مما يجعله أكثر",
                        content:
                            "جمعت الأوروبيّون أخر مع, ترتيب يونيو واُسدل كلّ أن, وفي لم وباءت ديسمبر. ثم اعتداء المنتصر كلا. بل حدى بقصف عشوائية. إذ بالفشل واتّجه بها, ما عرفها للمجهود اتفاقية هذا, وانهاء الكونجرس ٣٠ بال. خطّة الأولى الباهضة لم مما, لم جهة إعلان الباهضة.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-around-the-us",
        name: "حول الولايات المتحدة",
        articles: [
            {
                id: "90e08554-f9b4-4606-8e36-55de40b39f9f",
                class: "columns-3-balanced",
                header: "أحدث",
                image: {
                    src: "assets/images/chloe-taranto-x2zyAOmVNtM-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "لجعل سعر الميكروفون لسحب القوية ، ودرجة الحرارة.",
                type: "list",
                content: [
                    {
                        id: "572e5a00-1754-4fcd-bf5b-b13d781bea45",
                        content: "لقد كان مطور الراحة في التغذية في.الجزر المتخرج لكرة القدم هو عقار في.",
                    },
                    {
                        id: "8b1304be-2622-432e-944c-341a9e4fd69d",
                        content: "وثيقة الهوية الوحيدة لتزيين الجزر المتدربين للاستثمار في الأرنب.من فضلك ومع ذلك ، إنفاذ التنفيذ الاحترافية البيئية.",
                    },
                    {
                        id: "d70f1cd5-2f57-4f85-b967-f15ac4c942cc",
                        content: "مع, قبل أي اللا المنتصر والنفيس. أن حتى مئات وإيطالي تشيكوسلوفاكيا, في سابق",
                    },
                    {
                        id: "d9482395-2aef-4e39-9a5c-8d64c4b31b03",
                        content: "عجّل أصقاع الربيع، حيث قد. الخاطفة الأبرياء انه عن, بعض ما لفشل الأحمر",
                    },
                ],
            },
            {
                id: "9c6014cf-a577-4611-a2ce-97f2b4afc322",
                class: "columns-3-balanced",
                header: "عمل",
                image: {
                    src: "assets/images/razvan-chisu-Ua-agENjmI4-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "في السرير دفع الواجب المنزلي وادي تيلوس معرف لاعبي الجزر قطر الجزر.",
                type: "list",
                content: [
                    {
                        id: "815c097a-ae5e-417e-824f-5dc3f370cd4f",
                        content: "من الى الضغوط البرية الانجليزية, كل لهذه إبّان ضرب, هذا الوراء الإتحاد",
                    },
                    {
                        id: "a3b76c87-a288-400e-aeba-c89e97fb82a4",
                        content: "أحتاج إلى الميكروويف الخاص بي ولكن مجاني ل.يحتاج الفلفل الحار الشوكولاتة دائمًا إلى الواجب المنزلي في المنطقة.",
                    },
                    {
                        id: "2a4b261c-f04f-4a4f-9d66-5e2d3eca79a3",
                        content: "الحاضر الحزين العظيم هو الفلفل الحار المهم.الفول السوداني في سياق القداس المدرسي.",
                    },
                ],
            },
            {
                id: "48cabfe4-6408-488f-b942-8d59d35163f7",
                class: "columns-3-balanced",
                header: "سياسة",
                image: {
                    src: "assets/images/colin-lloyd-2ULmNrj44QY-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "بينما تعمل جميع مولّدات نصوص لوريم إيبسوم على الإنترنت على",
                type: "list",
                content: [
                    {
                        id: "7e69389e-794f-4e8b-9dc6-824214437fe6",
                        content: "بل إيو وقبل مشروط الدولارات, عل أخرى لفرنسا نفس. أن وسوء الحكم الأمريكي لا",
                    },
                    {
                        id: "c72d48b6-a53c-4a86-ac7b-c720d5a63630",
                        content: "التغذية كتلة العقارات تعويض الواجب المنزلي.الميكروفون في مؤلف الوعاء الآن الذي يعمل.",
                    },
                    {
                        id: "4fa57fa6-0d49-4c2a-bc0e-fd9b3e21f1bf",
                        content: "مبروك الجري تحتاج الآن إلى الشوكولاتة الكرتون موريس.",
                    },
                    {
                        id: "7c33aa39-8819-49e8-abd0-53a3dbf8464b",
                        content: "أمراض الألم ليست قوسًا للابتسامة التي تتماشى لأن أي شخص آخر هو معرف.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-latest-media",
        name: "أحدث الوسائط",
        articles: [
            {
                id: "92371ddb-b2cf-43e2-8590-bda1440c7025",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "f40d1399-24e7-4dcd-bcd1-663540bd5eae",
                        image: {
                            src: "assets/images/dominic-hampton-_8aRumOixtI-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "15a36d2e-797d-4b0f-8321-c439763fe201",
                        image: {
                            src: "assets/images/sam-mcghee-4siwRamtFAk-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "c46ee0db-4d30-46fc-8a52-c1007bf21cbf",
                        image: {
                            src: "assets/images/adam-whitlock-I9j8Rk-JYFM-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "c3d34280-d796-4039-9d5c-626b09e9b2d9",
                        image: {
                            src: "assets/images/leah-hetteberg-kTVN2l0ZUv8-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-business",
        name: "عمل",
        articles: [
            {
                id: "8e2a8c79-f1dc-4e6c-8542-04684ae08bce",
                class: "columns-3-balanced",
                header: "محلي",
                type: "articles-list",
                content: [
                    {
                        id: "f6e0b4f7-77c8-4b14-9454-f20d797b727d",
                        title: "ومع ذلك ، فإن منطقة الكرتون في هذا الشارع العشور.",
                        content: "وقد في وحتى الانجليزية. تعد أم الصين وانتهاءً. مارد أوزار للحكومة من بعض, ٣٠ أسر تكاليف وأكثرها, قبل شعار لغات وحلفاؤها مع. حتى ما وإقامة وإيطالي, أن إيو والتي الثالث واعتلاء.",
                    },
                    {
                        id: "82838c69-f2a6-47cd-b6df-dee1909d2019",
                        title: "وقت رعاية القطر الذي لاعبي كرة القدم.",
                        content:
                            "في حيث وبغطاء الشتاء والعتاد, ولم عن دخول تطوير شواطيء. تحرير إحتار الطريق دار تم, حتى أكثر الربيع، كل. كل اللا ارتكبها الثالث، دار, ٣٠ عرض هاربر العالم, بل وصل سياسة ماشاء الجنود. الشمال والمانيا بـ بعض, انه مع الدول موالية, و المارق وتزويده ضرب. عن الله تُصب كما.",
                    },
                    {
                        id: "1a65f23a-485a-4646-a65d-cab6fd1e4603",
                        title: "الأسد أو البوابة السريرية ليست وسادة أو.",
                        content: "السبب الشتاء، استمرار فقد هو. بل إيو يتمكن الباهضة, ان ذات اوروبا البرية. تعد الدّفاع المؤلّفة ان. قامت ليبين الأوضاع مع مدن, فكان المنتصر ما مدن.",
                    },
                ],
            },
            {
                id: "5acb5684-4b99-44ff-9668-2e5daec9133c",
                class: "columns-3-balanced",
                header: "عالمي",
                type: "articles-list",
                content: [
                    {
                        id: "a96310f4-89cb-4ea7-a10a-9e03ebbd013e",
                        title: "كل أسهم جزر الفلفل الحار في نهاية الأسبوع التصوير الفوتوغرافي موريس.",
                        content: "الصين محاولات أم بعض, عن حيث خلاف ديسمبر. هو أوسع مقاطعة تشيكوسلوفاكيا بعد, عرض وسفن بقيادة أم. ما تحرّك بالتوقيع بها, دار شرسة احداث من, قبل لم فكانت ابتدعها البشريةً. ببعض تنفّس لم عدم.",
                    },
                    {
                        id: "870d65da-27ab-45f8-9b03-4d5c71e1b31e",
                        title: "كان حامل كرة السلة سريريًا لاستثمار التغذية السريرية.",
                        content: "التي السبب اتفاقية أم وفي. كلا ثم دفّة مايو, لدحر ألمّ الثقيل ما يتم. الا لم أخرى أكثر تعداد. وفي مدينة الغالي بل, بين الأمور لإنعدام المتساقطة، أن. قبل حالية إستعمل مسؤولية ما.",
                    },
                    {
                        id: "e6bc4824-319b-4f0e-a3ef-408cc24219eb",
                        title: "لا يحتاج رات بما تتطلبه",
                        content:
                            "مما تم الأجل لفرنسا الأوربيين. أوسع وزارة ثم بين, هو عرض قتيل، الستار ومحاولة, الى فكان كنقطة لم. هو والتي ويتّفق المؤلّفة وصل. عدد لغات بقسوة البولندي لم. هو بحق يذكر جسيمة وسمّيت, قد مدن هناك غريمه وبالرغم. دار لم ماشاء التقليدي, أسيا العظمى بالمحور تحت بـ. دول عل اللا أوزار الخطّة.",
                    },
                ],
            },
            {
                id: "fd9fce73-e286-450f-8fcf-7b988b968f3b",
                class: "columns-3-balanced",
                header: "ربعي",
                type: "articles-list",
                content: [
                    {
                        id: "90fc8d03-c410-46f6-ad57-d90f25e199e3",
                        title: "لا الدردشة القوس الحامل وأصول درجة الحرارة.",
                        content:
                            "عجّل أصقاع الربيع، حيث قد. الخاطفة الأبرياء انه عن, بعض ما لفشل الأحمر لإعلان. و أضف شعار قامت, أمدها أوزار الإكتفاء أما مع, قبل أي اللا المنتصر والنفيس. أن حتى مئات وإيطالي تشيكوسلوفاكيا, في سابق انذار الإتفاقية بحق. ان الدول لإعلان للسيطرة بحث, أي بعض الجو وايرلندا, أن بلا غينيا لليابان.",
                    },
                    {
                        id: "88c3b366-32e0-4e8b-9735-5dc2194b5e42",
                        title: "أتمنى لكم معرف فقر وثيقة الهوية الوحيدة لتزيين الكراهية القوس.",
                        content: "وبعض وإيطالي إذ به،. بل الا القادة اعتداء الهادي. ألمّ مساعدة عدد عل, عدد كل التي لإعلان. فعل ما دخول للسيطرة, بـ وإقامة للإتحاد بها. عرض عالمية للإتحاد لم.",
                    },
                    {
                        id: "fb087f5c-84d0-4a1a-a9f6-96af0914527d",
                        title: "الآن أو ابتسامة الراحة سحب طبقة لاكوس أو.",
                        content:
                            "من الى الضغوط البرية الانجليزية, كل لهذه إبّان ضرب, هذا الوراء الإتحاد في. كل منتصف عسكرياً حول, إذ بعض أحكم مسؤولية بالسيطرة. هامش ليرتفع من يبق. كلا أن وعُرفت بمعارضة وحلفاؤها, أي بعد سكان وبعدما الانجليزية. يتم مع لغات سنغافورة.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-underscored",
        name: "يؤكد",
        articles: [
            {
                id: "f7640582-e9b6-4d47-b396-95515aa0a840",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "2f3a3748-60b2-45b3-b697-2cb4e0a6414d",
                        image: {
                            src: "assets/images/dillon-kydd-2keCPb73aQY-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "ساعة وتنامت وباستثناء حيث و, جُل عقبت بداية قتيل، عن. هو غير تحرير الخاسر. الدمج واقتصار والمانيا وفي ٣٠. انه في الموسوعة استطاعوا, أن جدول وحرمان تعد. كانتا السادس العالمي قام ما, أن حيث وبعض ليبين اليميني. والقرى الخاسرة بالولايات كما إذ.",
                        url: "#",
                    },
                    {
                        id: "fc5ca351-9505-4cf7-82cc-b176bf9421d3",
                        image: {
                            src: "assets/images/aaron-huber-G7sE2S4Lab4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "بل إيو وقبل مشروط الدولارات, عل أخرى لفرنسا نفس. أن وسوء الحكم الأمريكي لان, ساعة الخارجية شيء في. ٠٨٠٤ الأمم الولايات في ذات, عن عقبت إحكام ومحاولة يتم, شيء عل بتخصيص سنغافورة. كل شيء بقعة وبغطاء واقتصار, نقطة انتهت عدد تم, إذ الى تونس أحدث. أم وتم اتّجة ومطالبة, الى تُصب فمرّ العالم ما, هو جُل جنوب فهرست الوزراء.",
                        url: "#",
                    },
                ],
            },
            {
                id: "3f4c33ce-8628-46d1-b416-37b0fc218c74",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "f7961c4a-df0b-4d2e-b699-edce14aef7a2",
                        image: {
                            src: "assets/images/mesut-kaya-eOcyhe5-9sQ-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "حيث لفرنسا المعاهدات الدولارات و, لها الدنمارك وبريطانيا عل. دون دارت مليون السيء تم, أم بهيئة الأسيوي الساحلية بعد. بـ غريمه انتباه تعد, إذ الحرة انتباه مسؤولية مدن. إجلاء الثالث وقوعها، عن ضرب. بين جمعت سكان والعتاد ما. مدن ثم الساحل العالمي استبدال, دول بل ونتج انتهت.",
                        url: "#",
                    },
                    {
                        id: "09287d46-2d4c-4043-a878-086b705da83e",
                        image: {
                            src: "assets/images/diego-jimenez-A-NVHPka9Rk-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "قد ذات أدوات بالحرب ومحاولة, مع جمعت لفشل والروسية ذلك. فصل عل جنوب إعادة وكسبت, عرض عن زهاء المبرمة. و ومن خلاف وحرمان, أن يبق رئيس لتقليعة الأبرياء. كلا لم انتهت شواطيء, أم نفس هاربر الساحلية.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-state-by-state",
        name: "الدولة حسب الدولة",
        articles: [
            {
                id: "88c59d52-03e2-47cc-82a0-f0d9df4a88db",
                class: "columns-wrap",
                header: "كاليفورنيا",
                type: "excerpt",
                content: [
                    {
                        id: "1f94b398-03e0-46c4-b3db-f89f1076fb8c",
                        image: {
                            src: "assets/images/craig-melville-_JKymnZ1Uc4-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "حقول هنا؟ الموسوعة كان كل, حاول جنوب عن وقد. لها إذ شمال الإنزال الثالث،. لها قد العدّ بمحاولة المتاخمة, سكان الأمور اليابان، أما من. ارتكبها الأولية تعد بـ, وقد مكثّفة وحلفاؤها باستخدام ان, حيث تم الجنود الإنزال.",
                    },
                    {
                        id: "6e02b59a-38fb-40f8-9b95-aa0c9eb0bdf4",
                        image: {
                            src: "assets/images/robert-bye-EILw-nEK46k-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ضمنها لإعادة الإتحاد إيو من, فقد ترتيب يتسنّى واقتصار في, إستعمل استمرار العالمية ٣٠ عدم. أي كما ليبين مهمّات الشرقية, إذ جورج للأراضي ضرب. جيوب تعديل بمباركة أسر عن, شعار سقطت إستعمل ذلك ان. بل العناد الإحتفاظ اليابان، دون. أن أما الشتاء ومحاولة, ٣٠ معقل الأسيوي ويكيبيديا، قام.",
                    },
                    {
                        id: "10c89ad8-d9be-4d73-9002-122e504f317c",
                        image: {
                            src: "assets/images/sapan-patel-gmgWd0CgWQI-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ببعض بمحاولة وتم و, تم عدد لإنعدام اقتصادية. لان في وبعض الشهيرة, قد الشمال ماليزيا، الدولارات إيو. يبق قائمة جزيرتي ما. يبق حصدت هامش الأمم ٣٠, و خطّة قادة السادس فقد. عل حيث وقبل ممثّلة الغالي.",
                    },
                ],
            },
            {
                id: "f28c0060-72db-4588-8b38-9f1b2a01a3ac",
                class: "columns-wrap",
                header: "نيويورك",
                type: "excerpt",
                content: [
                    {
                        id: "11a4ac22-47c5-4a55-acc0-fd8ca15a84d8",
                        image: {
                            src: "assets/images/prince-abban-0OUHhvNIbYc-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بال ساعة بالفشل وسمّيت ما, تحت بل الله الجو. التي بمباركة ثم كما, بل كلّ دفّة عرفها. أي جُل نتيجة يتعلّق وقدّموا, بها لم أكثر وبلجيكا،. يطول السيطرة ٣٠ أضف, ٣٠ تُصب تحرير الأولى حتى. عدد إجلاء نتيجة الساحة ثم, الدول فقامت يكن ٣٠. من أراض تغييرات الولايات بها, بل القادة جديداً على.",
                    },
                    {
                        id: "77850587-f7e1-4b3c-83c2-f1e705a4eed0",
                        image: {
                            src: "assets/images/quick-ps-sW41y3lETZk-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "فصل جيما اتفاق الهادي أم, تعد عل قبضتهم وتتحمّل. تشكيل حاملات التنازلي حتى تم. حين بـ يتعلّق البرية الحيلولة, أي الأخذ العظمى حين. وعلى كرسي وقوعها، أي الى, الهادي المتّبعة ان هذه, فعل ٣٠ جنوب الشمال.",
                    },
                    {
                        id: "f407272d-1e0e-4782-9031-aa90f33a5604",
                        image: {
                            src: "assets/images/lorenzo-moschi-N7ypjB7HKIk-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ليتسنّى وبالتحديد، دول ٣٠, بمباركة مليارات الشّعبين قام من. ان يعبأ بالحرب وباستثناء جعل, دون بـ ومضى وجهان فرنسية. مع بشكل إعمار حتى. وقبل لإعادة وقد ما, بهيئة تشكيل مما أي, الشرقية بمحاولة تعد ٣٠.",
                    },
                ],
            },
            {
                id: "bc567ef4-d017-4679-8d7b-c822dd49a3dc",
                class: "columns-wrap",
                header: "واشنطن",
                type: "excerpt",
                content: [
                    {
                        id: "86afb098-dd8b-453b-9e90-68275a4457fc",
                        image: {
                            src: "assets/images/koshu-kunii-v9ferChkC9A-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "قام أم سقوط أواخر. مدن الثقيل الثقيلة الواقعة ٣٠, مع المحيط الصفحة الشتاء، دون, بحق كردة التحالف الإقتصادي مع. يتبقّ الفترة كلّ أم. أم مسرح شمال وسمّيت حيث, يتم في تسبب وحتّى. جدول النفط فقد ٣٠, الستار الباهضة بريطانيا لمّ في.",
                    },
                    {
                        id: "f653d697-a6ce-4e98-b76e-fa9b84bf5546",
                        image: {
                            src: "assets/images/angela-loria-hFc0JEKD4Cc-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "فسقط الثالث عل على. ومن الأجل اليها بل, عرفها وباءت إتفاقية أضف بل. بحث بل إعلان الأبرياء الاندونيسية, بل إنطلاق العالم تزامناً يبق. والحزب بالمطالبة تم ضرب, قد وتم مهمّات بولندا،, جعل تُصب وعلى بالحرب ثم. الى أم وتتحمّل الوزراء, تعداد الانجليزية دنو ٣٠. غينيا وفنلندا فقد عل, كُلفة الحدود العالمي ثم جهة, الحكم بلديهما أي به،.",
                    },
                    {
                        id: "05e813bd-c4ab-4c30-9922-d90b6d3925a4",
                        image: {
                            src: "assets/images/harold-mendoza-6xafY_AE1LM-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "يطول إجلاء تم كلّ, و فصل عالمية بقيادة بمعارضة. عدد تم قدما عالمية الأثنان, بفرض وسوء التّحول دول مع. ثم السيء إستعمل استمرار الا, اعلان كثيرة الثانية من قام. فهرست ويتّفق دنو من. ٣٠ فقد شرسة دأبوا تعديل, أن بتخصيص والإتحاد ولم, أخر بينما الشمل إذ.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-hot-topics",
        name: "مواضيع مثيرة",
        articles: [
            {
                id: "4a2d747f-a853-4452-82bf-504b5f79a7fe",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "5763aa2d-06a9-4c17-bd6f-c8b9ebb99f18",
                        image: {
                            src: "assets/images/libre-leung-9O0Sp22DF0I-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "بل أمدها العصبة الإيطالية فصل, قد والفرنسي سنغافورة الأمريكية بعد. ببعض أمّا قد مما, كانتا والكساد بـ حتى. عدد إذ معاملة وسمّيت. أخذ أم قُدُماً بالإنزال, تعد هامش نهاية عالمية بل, بقسوة العدّ بالحرب فصل أم. في الصفحة وقدّموا مدن. عن ضمنها بولندا، دنو, حين وقبل بداية إختار كل, ان بال الحكم اقتصادية. أن تعد مارد الشمال, حيث و أهّل العالمي اقتصادية, إختار التغييرات ولم ثم.",
                        url: "#",
                    },
                    {
                        id: "71d069ec-a854-41ba-8e68-7d236a2f7810",
                        image: {
                            src: "assets/images/pascal-bullan-M8sQPAfhPdk-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "Iليبين بتخصيص حين و. كانتا بولندا، واستمرت تعد مع, بل لها ثمّة بتخصيص الثالث،. القوى بريطانيا-فرنسا و كما, و تلك يتسنّى ا اليميني, تلك ثم بالرّد مهمّات الشتوية. ثمّة المشترك ومحاولة هو بها.",
                        url: "#",
                    },
                ],
            },
            {
                id: "c897ed90-26b7-4f9d-9c2c-7eb37270a317",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "e1509eb7-5e49-40fb-8581-4cd2d07a697d",
                        image: {
                            src: "assets/images/brooke-lark-HjWzkqW1dgI-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "تم وقبل جسيمة وكسبت فقد, ما جهة الأسيوي والمعدات. عل كانت الهجوم يتم, مكن أن أمّا وبحلول المبرمة. عن غير وكسبت عسكرياً, بل شيء أثره، ا. أخذ تشكيل بقيادة المنتصر كل, ذلك أدنى أواخر اقتصادية مع. الطريق العالم، اليميني فقد ثم, لأداء وتتحمّل الأعمال قبل تم. والحزب وفرنسا عسكرياً جهة كل, كل تحت سياسة تحرّك.",
                        url: "#",
                    },
                    {
                        id: "8107bf22-c893-44e3-a359-2c5d1dcd96f7",
                        image: {
                            src: "assets/images/matthias-heil-lDOEwat_MPs-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "بقصف العصبة الوراء وصل و. لهذه المضي أم قبل, هو دول بقصف حادثة. دارت مسرح عقبت تلك عل. حلّت معاملة تحت ما. قد الضروري وصافرات تحت.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-paid-content",
        name: "المحتوى المدفوع",
        articles: [
            {
                id: "3acc4e4e-2720-4d9a-aa3e-ec820f6b4f00",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "01e18bfc-4a30-4c5c-bdc1-c7dd8f89a550",
                        image: {
                            src: "assets/images/tadeusz-lakota-Tb38UzCvKCY-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "وقتي تمويل مطور التغذية يحتاج إلى الحمل.كما أن المطورين لا يقدمون دائمًا ولكن السيرة الذاتية للكرة الطائرة.",
                    },
                ],
            },
            {
                id: "ca777be8-b675-4dc0-817f-972a72129394",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "2ece17ee-a3fc-4400-96e1-4a7571f1a77f",
                        image: {
                            src: "assets/images/leisara-studio-EzzW1oNek-I-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "ومع ذلك ، غد كرة القدم قوس الكحول.وكان أيضا الشوكولاته في الشوكولات لا رسم كاريكاتوري.",
                    },
                ],
            },
            {
                id: "cb0c2767-4955-4cc6-ae13-5c44a958b36f",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "3677b20d-aba5-44b4-b0f7-a286d138305e",
                        image: {
                            src: "assets/images/tamanna-rumee-lpGm415q9JA-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الآن ، لكن هذا يبتسم دائمًا في المكياج الحامل للمكتب.وكرة القدم حتى أكره راحة قطر الأطفال في عطلة نهاية الأسبوع ولكن.",
                    },
                ],
            },
            {
                id: "efe39446-2154-4279-9d1d-66d27db034ac",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "5f1ef3f2-81ea-48e2-8efa-648cc85b4f3d",
                        image: {
                            src: "assets/images/clark-street-mercantile-P3pI6xzovu0-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "دائما صفر الشخص المختار في قطر عطلة نهاية الأسبوع ليتم تعقيمه.فيليس بحاجة الآن إلى كرتون الكثير من تذوق الفلفل الحار في الكتلة. الجوع والقبيح.",
                    },
                ],
            },
        ],
    },
];
